import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { HubInvoiceListPage } from '@/features/hub-invoices'

export const Route = createFileRoute('/_authenticated/billing/hub-invoices')({
  component: () => (
    <RequirePermission permission='hub_invoices.read'>
      <HubInvoiceListPage />
    </RequirePermission>
  ),
})
